import { render, staticRenderFns } from "./ProcedureCard.vue?vue&type=template&id=1f73f6cc&"
import script from "./ProcedureCard.vue?vue&type=script&lang=js&"
export * from "./ProcedureCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports